import { CURRENCY_MAP } from '../../../constants/purchaseInvoices/approvalPackages/approvalPackageDetailsConstants';

export const displayPriceForCreditInvoice = (price, isCreditInvoice) => {
  if (!isCreditInvoice) return price;
  const numPrice = Number(price || 0);
  return -Math.abs(numPrice);
};

export const getCurrencySymbol = (code) => {
  if (!code) return '₪'; 
  return CURRENCY_MAP[code.toString().trim().toUpperCase()] || 
         CURRENCY_MAP[code] || 
         code;
};

export const formatPriceWithCurrency = (amount, currencyCode, itemData = null, displayCurrency = null, isCreditInvoice = false) => {
  const symbol = getCurrencySymbol(currencyCode);
  let num = Number(amount || 0);
  
  if (isCreditInvoice) {
    num = -Math.abs(num);
  }
  
  const formatted = num.toLocaleString('he-IL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  
  return `${symbol}${formatted}`;
};

export const formatPrice = (price, isCreditInvoice = false) => {
  let num = Number(price || 0);
  
  if (isCreditInvoice) {
    num = -Math.abs(num);
  }
  
  return new Intl.NumberFormat('he-IL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
};

export const getFormattedPrice = (value, isCreditInvoice = false) => {
  let num = Number(value || 0);
  
  if (isCreditInvoice) {
    num = -Math.abs(num);
  }
  
  return num; 
};

export const calculateUpdatedOrderData = (orderData) => {
  if (!orderData || !orderData.items) {
    return orderData;
  }

  const updatedItems = orderData.items.map(orderItem => {
    let totalReceivedQuantity = 0;
    
    if (orderItem.RELEVANT_MOVEMENTS && orderItem.RELEVANT_MOVEMENTS.length > 0) {
      orderItem.RELEVANT_MOVEMENTS.forEach((movement, index) => {
        totalReceivedQuantity += movement.TQUANT || 0;
      });
    } else {
      totalReceivedQuantity = orderItem.TQUANT;
    }
    
    const originalQuantity = orderItem.TQUANT;
    const originalTotalPrice = orderItem.QPRICE;
    const originalTotalPriceWithVat = orderItem.VATPRICE;
    const exchangeRate = orderItem.EXCH || 1; 
    
    const unitPrice = originalTotalPrice / exchangeRate / originalQuantity;
    const unitPriceWithVat = originalTotalPriceWithVat / exchangeRate / originalQuantity;
    
    const originalUnitPrice = originalTotalPrice / originalQuantity;
    const originalUnitPriceWithVat = originalTotalPriceWithVat / originalQuantity;
    const newTotalPrice = totalReceivedQuantity * originalUnitPrice;
    const newTotalPriceWithVat = totalReceivedQuantity * originalUnitPriceWithVat;

    return {
      ...orderItem,
      TQUANT: totalReceivedQuantity,        
      QPRICE: newTotalPrice,               
      VATPRICE: newTotalPriceWithVat,      
      PRICE: unitPrice,                    
      ORIGINAL_QUANTITY: originalQuantity,
      ORIGINAL_TOTAL: originalTotalPrice,
      RECEIPT_INFO: orderItem.RECEIPT_INFO || null
    };
  });

  const newQPrice = updatedItems.reduce((sum, item) => sum + item.QPRICE, 0);
  const newTotPrice = updatedItems.reduce((sum, item) => sum + item.VATPRICE, 0);
  const newVat = newTotPrice - newQPrice;

  const result = {
    ...orderData,
    items: updatedItems,
    totals: {
      ...orderData.totals,
      QPRICE: newQPrice,
      TOTPRICE: newTotPrice,
      VAT: newVat
    }
  };

  return result;
};

export const getOrderDisplayText = (order) => {
  if (order?.MULTIPLE_ORDERS && order?.ALL_ORDERS && order.ALL_ORDERS.length > 1) {
    return `הזמנות: ${order.ALL_ORDERS.join(', ')}`;
  } else if (order?.ALL_ORDERS && order.ALL_ORDERS.length === 1) {
    return `הזמנה: ${order.ALL_ORDERS[0]}`;
  } else {
    return `הזמנה: ${order?.ORDNAME}`;
  }
};

export const getMappingColor = (mappingNumber, MAPPING_COLORS) => {
  const colorIndex = (mappingNumber - 1) % MAPPING_COLORS.length;
  return MAPPING_COLORS[colorIndex];
};

export const cleanMappings = (mappings, orderItemsCount, invoiceItemsCount) => {
  return mappings
    .map(mapping => {
      const originalIndices = mapping.invoiceLineIndices;
      const filteredIndices = mapping.invoiceLineIndices.filter(idx => idx < invoiceItemsCount);
      
      if (originalIndices.length !== filteredIndices.length) {
        console.warn(`Removed invalid invoice indices for order line ${mapping.orderLineIndex}`, 
          originalIndices.filter(idx => idx >= invoiceItemsCount)
        );
      }
      
      return {
        ...mapping,
        invoiceLineIndices: filteredIndices
      };
    })
    .filter(mapping => {
      if (mapping.orderLineIndex >= orderItemsCount) {
        console.warn(`Removed mapping with invalid order index: ${mapping.orderLineIndex}`);
        return false;
      }
      return true;
    })
    .filter(mapping => {
      if (mapping.invoiceLineIndices.length === 0) {
        console.warn(`Removed empty mapping for order line: ${mapping.orderLineIndex}`);
        return false;
      }
      return true;
    });
};
